import axios, { type AxiosRequestConfig } from 'axios'

const API_BASE = (import.meta.env.VITE_APP_API_GATEWAY_URL as string) ?? ''
const TOKEN_KEY = 'access_token'

function authHeaders() {
  return {
    Authorization: `Bearer ${sessionStorage.getItem(TOKEN_KEY)}`,
  }
}

export async function apiGet<T = unknown>(
  path: string,
  params?: Record<string, string | number | undefined>,
  config?: AxiosRequestConfig
): Promise<{ success: boolean; data?: T; message?: string }> {
  try {
    const response = await axios.get<T>(`${API_BASE}${path}`, {
      headers: authHeaders(),
      params,
      ...config,
    })
    return { success: true, data: response.data }
  } catch (error: unknown) {
    const msg =
      (error as any)?.response?.data?.message ??
      (error as any)?.message ??
      'Request failed'
    return { success: false, message: msg }
  }
}

export async function apiPost<T = unknown>(
  path: string,
  body: Record<string, unknown> | FormData,
  config?: AxiosRequestConfig
): Promise<{ success: boolean; data?: T; message?: string }> {
  try {
    const isFormData = body instanceof FormData
    const response = await axios.post<T>(`${API_BASE}${path}`, body, {
      headers: {
        ...authHeaders(),
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      },
      ...config,
    })
    return { success: true, data: response.data }
  } catch (error: unknown) {
    const msg =
      (error as any)?.response?.data?.message ??
      (error as any)?.message ??
      'Request failed'
    return { success: false, message: msg }
  }
}

export async function apiPut<T = unknown>(
  path: string,
  body: Record<string, unknown>,
  config?: AxiosRequestConfig
): Promise<{ success: boolean; data?: T; message?: string }> {
  try {
    const response = await axios.put<T>(`${API_BASE}${path}`, body, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      ...config,
    })
    return { success: true, data: response.data }
  } catch (error: unknown) {
    const msg =
      (error as any)?.response?.data?.message ??
      (error as any)?.message ??
      'Request failed'
    return { success: false, message: msg }
  }
}

export async function apiDelete<T = unknown>(
  path: string,
  config?: AxiosRequestConfig
): Promise<{ success: boolean; data?: T; message?: string }> {
  try {
    const response = await axios.delete<T>(`${API_BASE}${path}`, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      ...config,
    })
    return { success: true, data: response.data }
  } catch (error: unknown) {
    const msg =
      (error as any)?.response?.data?.message ??
      (error as any)?.message ??
      'Request failed'
    return { success: false, message: msg }
  }
}
